import { render } from "./detail-insurance-information.vue?vue&type=template&id=a6f7b208"
import script from "./detail-insurance-information.vue?vue&type=script&lang=js"
export * from "./detail-insurance-information.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__